import Loadable from 'react-loadable';
import ColumnsContent from 'components/Hocs/ColumnsContent/ColumnsContent';
import MediumPreLoader from 'components/Common/PreLoaders/MediumPreLoader';

export default Loadable({
  loader: () => import('./ApiDocsColumnsContentWrapped'),
  loading: ColumnsContent(MediumPreLoader)
});



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutApp/Content/ApiDoc/ApiDocsLoadableWrapped/index.js